exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/vue-loader/lib/style-rewriter.js?id=data-v-7b21ed10!../~/vue-loader/lib/selector.js?type=styles&index=0!./components/vue/getaward.vue
 ** module id = 133
 ** module chunks = 1
 **/